/* eslint-disable import/prefer-default-export */

/**
 * Object map for all available engines the arcade can load. Arranging them with
 * individual import functions facilitates loading them on demand, minimizes initial
 * arcade load time, and prevents loading unnecessary code into memory.
 * @enum {typeof ENGINES[keyof typeof ENGINES]}
 */
export const ENGINES = Object.freeze({
	advent: 'advent',
	ballot: 'ballot',
	ballotPicker: 'ballot',
	bracket: 'bracket',
	connectFour: 'connectFour',
	crossword: 'crossword',
	dag: 'dag',
	documentViewer: 'documentViewer',
	doubleExposure: 'dx',
	gamePool: 'gamePool',
	home: 'home',
	jigScene: 'jigScene',
	leaderboards: 'leaderboards',
	lockBox: 'lockbox',
	loginGate: 'hwptvLoginGate',
	cognitoLoginGate: 'cognitoLoginGate',
	maze: 'maze',
	memoryMatch: 'mm',
	movieCubes: 'movieCubes',
	guide: 'guide',
	path: 'path',
	raffle: 'raffle',
	cognitoRegistration: 'registration',
	sceneStreak: 'sceneStreak',
	sectionedMenu: 'sectionedMenu',
	slidePuzzle: 'slidePuzzle',
	sportSchedule: 'sportSchedule',
	survey: 'survey',
	sweepstakes: 'sweepstakes',
	teamChooser: 'teamChooser',
	teamStandings: 'teamStandings',
	tilePop: 'tilePop',
	tileSwap: 'tileSwap',
	trivia: 'trivia',
	videoCarousel: 'videoCarousel',
	videoPage: 'video',
	wellConnected: 'wellConnected',
	wordSearch: 'wordSearch',
});
